import { createReducer } from '../../../utilities';

import { scope } from '../../../../actions/app/onSite/matches/listWidget';
import {
    REQUEST_FETCH_MATCHES,
    SUCCESS_FETCH_MATCHES,
    FAIL_FETCH_MATCHES,
} from '../../../../actions/entities/match';

const initialMatchesListWidgetState = {
    ids: null,
    day: '',
    info: {
        isFetching: false,
        lastAction: null,
        lastPayload: {},
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false
    }
};

function request(state, action) {
    return {
        ...state,
        day: action.payload.day,
        info: {
            isFetching: true,
            lastAction: action.type,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false
        }
    };
}

function success(state, action) {
    const { ids, payload, receivedAt, success } = action;

    return {
        ...state,
        ids: ids || state.ids,
        day: action.day,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false
        }
    };
}

function fail(state, action) {
    const { error, payload, type } = action;
    return {
        ...state,
        ids: type === FAIL_FETCH_MATCHES ? null : state.ids,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            success: false,
            error
        }
    };
}

export default createReducer(initialMatchesListWidgetState, {
    [REQUEST_FETCH_MATCHES]: request,
    [SUCCESS_FETCH_MATCHES]: success,
    [FAIL_FETCH_MATCHES]: fail
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/matches/listWidget.js